// 现场签到相关
import merge from "lodash/merge"
import { Signup } from "./signup"

class SignInTicket {
  constructor() {
    this.id = 0
    this.timestamp = 0
    this.sign = ""
  }

  static async getSignInTicket(signup_id) {
    const url =
      process.env.VUE_APP_API_URL + `api/v1/signin/${signup_id}/ticket`
    const res = await axios.post(url)
    let item = Object.assign(new SignInTicket(), res.data)
    return item
  }

  static async verifyTicket(ticket) {
    // 验证SignInTicket
    const url = process.env.VUE_APP_API_URL + "api/v1/signin/ticket_verify"
    const res = await axios.post(url, ticket)
    if (res.data.result == true) {
      return true
    } else {
      return false
    }
  }

  static async signIn(signup_id) {
    // 管理员签到二维码
    const url =
      process.env.VUE_APP_API_URL + `/api/v1/signin/${signup_id}/finish`
    const res = await axios.post(url)
    const item = merge(new Signup(), res.data.result)
    return item
  }
}

export { SignInTicket }
